export const datQualityHistoryChartBlankslate = (
  <svg width="100%" height="100%" viewBox="0 0 1689 587" fill="none">
    <rect x="1599" y="4" width="90" height="14" rx="7" fill="#F0F0F0" />
    <path
      d="M9.271 339.209C10.8029 339.209 11.9751 339.626 12.7876 340.46C13.5959 341.289 14 342.485 14 344.046L14 346.617L4.71973 346.617L4.71973 343.773C4.71973 342.33 5.11963 341.209 5.91943 340.409C6.71924 339.609 7.83642 339.209 9.271 339.209ZM9.30908 340.352C8.09879 340.352 7.18685 340.657 6.57324 341.266C5.95963 341.871 5.65283 342.773 5.65283 343.97L5.65283 345.538L13.0669 345.538L13.0669 344.224C13.0669 342.938 12.7516 341.971 12.1211 341.323C11.4863 340.676 10.549 340.352 9.30908 340.352ZM9.34717 329.079C10.5363 329.079 11.5244 329.318 12.3115 329.796C13.0986 330.274 13.6318 330.949 13.9111 331.821L16.209 329.612L16.209 331.18L14.1143 332.989L14.127 333.338C14.127 334.705 13.7101 335.761 12.8765 336.505C12.0386 337.246 10.8579 337.616 9.33447 337.616C7.82373 337.616 6.65364 337.244 5.82422 336.499C4.99056 335.754 4.57373 334.696 4.57373 333.325C4.57373 331.992 4.99691 330.951 5.84326 330.202C6.68961 329.453 7.85758 329.079 9.34717 329.079ZM9.34717 336.474C10.604 336.474 11.5583 336.207 12.21 335.674C12.8574 335.136 13.1812 334.358 13.1812 333.338C13.1812 332.31 12.8574 331.533 12.21 331.008C11.5625 330.484 10.6082 330.221 9.34717 330.221C8.09879 330.221 7.15299 330.484 6.50976 331.008C5.8623 331.529 5.53857 332.301 5.53857 333.325C5.53857 334.354 5.86442 335.136 6.51611 335.674C7.16357 336.207 8.10726 336.474 9.34717 336.474ZM11.5308 318.389C12.3475 318.389 12.9844 318.685 13.4414 319.278C13.8984 319.87 14.127 320.674 14.127 321.69C14.127 322.79 13.9852 323.637 13.7017 324.229L12.6606 324.229C12.8215 323.848 12.9484 323.433 13.0415 322.985C13.1346 322.536 13.1812 322.092 13.1812 321.652C13.1812 320.932 13.0457 320.391 12.7749 320.027C12.4998 319.663 12.119 319.481 11.6323 319.481C11.3107 319.481 11.0483 319.547 10.8452 319.678C10.6379 319.805 10.4474 320.021 10.2739 320.325C10.1004 320.626 9.90364 321.085 9.68359 321.703C9.37467 322.566 9.00862 323.184 8.58545 323.556C8.16227 323.924 7.61002 324.108 6.92871 324.108C6.21354 324.108 5.64437 323.84 5.22119 323.302C4.79801 322.765 4.58642 322.054 4.58642 321.169C4.58642 320.247 4.75569 319.398 5.09424 318.624L6.03369 318.96C5.71207 319.726 5.55127 320.471 5.55127 321.195C5.55127 321.766 5.67399 322.213 5.91943 322.534C6.16487 322.856 6.50553 323.017 6.9414 323.017C7.26302 323.017 7.5275 322.957 7.73486 322.839C7.93799 322.72 8.1263 322.521 8.2998 322.242C8.46907 321.959 8.65739 321.527 8.86474 320.947C9.21175 319.974 9.58415 319.305 9.98193 318.941C10.3797 318.573 10.896 318.389 11.5308 318.389ZM14.127 313.87C14.127 314.877 13.818 315.658 13.2002 316.212C12.5781 316.762 11.7 317.037 10.5659 317.037C9.40218 317.037 8.50293 316.758 7.86816 316.199C7.2334 315.636 6.91601 314.837 6.91601 313.8C6.91601 313.465 6.95198 313.131 7.02392 312.797C7.09586 312.463 7.1805 312.2 7.27783 312.01L8.17285 312.333C8.07975 312.566 8.00358 312.82 7.94433 313.095C7.88086 313.37 7.84912 313.614 7.84912 313.825C7.84912 315.239 8.75049 315.945 10.5532 315.945C11.408 315.945 12.064 315.774 12.521 315.431C12.978 315.084 13.2065 314.572 13.2065 313.895C13.2065 313.315 13.0817 312.721 12.832 312.111L13.7651 312.111C14.0063 312.577 14.127 313.163 14.127 313.87ZM10.5151 304.45C11.6492 304.45 12.5358 304.735 13.1748 305.307C13.8096 305.878 14.127 306.667 14.127 307.674C14.127 308.296 13.981 308.849 13.689 309.331C13.397 309.813 12.978 310.186 12.4321 310.448C11.8862 310.711 11.2472 310.842 10.5151 310.842C9.38102 310.842 8.4987 310.558 7.86816 309.991C7.2334 309.424 6.91601 308.637 6.91601 307.63C6.91601 306.657 7.23974 305.884 7.8872 305.313C8.53467 304.737 9.41064 304.45 10.5151 304.45ZM10.5151 309.75C11.4038 309.75 12.0809 309.572 12.5464 309.217C13.0119 308.861 13.2446 308.339 13.2446 307.649C13.2446 306.959 13.014 306.437 12.5527 306.081C12.0872 305.721 11.408 305.542 10.5151 305.542C9.63069 305.542 8.95996 305.721 8.50293 306.081C8.04166 306.437 7.81103 306.963 7.81103 307.662C7.81103 308.351 8.03743 308.872 8.49023 309.223C8.94303 309.574 9.618 309.75 10.5151 309.75ZM6.91601 299.422C6.91601 299.113 6.9414 298.836 6.99218 298.591L7.96972 298.737C7.90625 299.025 7.87451 299.278 7.87451 299.499C7.87451 300.061 8.10302 300.544 8.56006 300.946C9.01709 301.344 9.58626 301.542 10.2676 301.542L14 301.542L14 302.596L7.04297 302.596L7.04297 301.727L8.33154 301.606L8.33154 301.555C7.87874 301.297 7.52962 300.986 7.28418 300.622C7.03873 300.258 6.91601 299.858 6.91601 299.422ZM14.127 294.351C14.127 295.379 13.8138 296.191 13.1875 296.788C12.5612 297.381 11.6916 297.677 10.5786 297.677C9.45719 297.677 8.5664 297.402 7.90625 296.852C7.24609 296.297 6.91601 295.555 6.91601 294.624C6.91601 293.752 7.20377 293.062 7.77929 292.554C8.35058 292.046 9.10595 291.792 10.0454 291.792L10.7119 291.792L10.7119 296.585C11.5286 296.564 12.1486 296.359 12.5718 295.969C12.995 295.576 13.2065 295.023 13.2065 294.312C13.2065 293.563 13.05 292.823 12.7368 292.091L13.6763 292.091C13.8371 292.463 13.9513 292.817 14.019 293.151C14.091 293.481 14.127 293.881 14.127 294.351ZM7.79834 294.636C7.79834 295.195 7.9803 295.641 8.34424 295.976C8.70817 296.306 9.21175 296.5 9.85498 296.56L9.85498 292.922C9.19059 292.922 8.68278 293.07 8.33154 293.367C7.97607 293.663 7.79834 294.086 7.79834 294.636Z"
      fill="#959596"
    />
    <rect width="197" height="22" rx="11" fill="#F0F0F0" />
    <rect x="54" y="551" width="32" height="14" rx="7" fill="#F0F0F0" />
    <rect x="54" y="406" width="32" height="14" rx="7" fill="#F0F0F0" />
    <rect x="54" y="357" width="32" height="14" rx="7" fill="#F0F0F0" />
    <rect x="54" y="309" width="32" height="14" rx="7" fill="#F0F0F0" />
    <rect x="54" y="261" width="32" height="14" rx="7" fill="#F0F0F0" />
    <rect x="54" y="212" width="32" height="14" rx="7" fill="#F0F0F0" />
    <rect x="54" y="164" width="32" height="14" rx="7" fill="#F0F0F0" />
    <rect x="54" y="67" width="32" height="14" rx="7" fill="#F0F0F0" />
    <rect x="54" y="115" width="32" height="14" rx="7" fill="#F0F0F0" />
    <rect x="54" y="502" width="32" height="14" rx="7" fill="#F0F0F0" />
    <rect x="54" y="454" width="32" height="14" rx="7" fill="#F0F0F0" />
    <line
      opacity="0.6"
      x1="111"
      y1="322.5"
      x2="1689"
      y2="322.5"
      stroke="#E6E6E6"
      strokeDasharray="2 2"
    />
    <line
      opacity="0.6"
      x1="111"
      y1="274.5"
      x2="1689"
      y2="274.5"
      stroke="#E6E6E6"
      strokeDasharray="2 2"
    />
    <line
      opacity="0.6"
      x1="111"
      y1="225.5"
      x2="1689"
      y2="225.5"
      stroke="#E6E6E6"
      strokeDasharray="2 2"
    />
    <line
      opacity="0.6"
      x1="111"
      y1="177.5"
      x2="1689"
      y2="177.5"
      stroke="#E6E6E6"
      strokeDasharray="2 2"
    />
    <line
      opacity="0.6"
      x1="111"
      y1="128.5"
      x2="1689"
      y2="128.5"
      stroke="#E6E6E6"
      strokeDasharray="2 2"
    />
    <line
      opacity="0.6"
      x1="111"
      y1="80.5"
      x2="1689"
      y2="80.5001"
      stroke="#E6E6E6"
      strokeDasharray="2 2"
    />
    <line
      opacity="0.6"
      x1="111"
      y1="419.5"
      x2="1689"
      y2="419.5"
      stroke="#E6E6E6"
      strokeDasharray="2 2"
    />
    <line
      opacity="0.6"
      x1="111"
      y1="370.5"
      x2="1689"
      y2="370.5"
      stroke="#E6E6E6"
      strokeDasharray="2 2"
    />
    <line
      opacity="0.6"
      x1="111"
      y1="467.5"
      x2="1689"
      y2="467.5"
      stroke="#E6E6E6"
      strokeDasharray="2 2"
    />
    <line
      opacity="0.6"
      x1="111"
      y1="515.5"
      x2="1683"
      y2="515.5"
      stroke="#E6E6E6"
      strokeDasharray="2 2"
    />
    <line x1="114" y1="564.5" x2="1683" y2="564.5" stroke="#E6E6E6" />
    <rect x="151" y="573" width="58.7211" height="14" rx="7" fill="#F0F0F0" />
    <rect
      x="1184.06"
      y="573"
      width="58.7211"
      height="14"
      rx="7"
      fill="#F0F0F0"
    />
    <rect
      x="357.611"
      y="573"
      width="58.7211"
      height="14"
      rx="7"
      fill="#F0F0F0"
    />
    <rect
      x="1390.67"
      y="573"
      width="58.7211"
      height="14"
      rx="7"
      fill="#F0F0F0"
    />
    <rect
      x="564.222"
      y="573"
      width="58.7211"
      height="14"
      rx="7"
      fill="#F0F0F0"
    />
    <rect
      x="1597.28"
      y="573"
      width="58.7211"
      height="14"
      rx="7"
      fill="#F0F0F0"
    />
    <rect
      x="770.833"
      y="573"
      width="58.7211"
      height="14"
      rx="7"
      fill="#F0F0F0"
    />
    <rect
      x="977.445"
      y="573"
      width="58.7211"
      height="14"
      rx="7"
      fill="#F0F0F0"
    />
  </svg>
);
